import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HSEProvider } from "./lib/store";
import { AuthProvider } from "./lib/auth";
import RequireAuth from "./components/RequireAuth";
import ErrorBoundary from "./components/ErrorBoundary";
import AppLayout from "./components/layout/AppLayout";
import Login from "./pages/Login";
import ExecutiveDashboard from "./pages/ExecutiveDashboard";
import MonthlyKPI from "./pages/MonthlyKPI";
import Incidents from "./pages/Incidents";
import Inspections from "./pages/Inspections";
import ActionPlan from "./pages/ActionPlan";
import PermitToWork from "./pages/PermitToWork";
import Training from "./pages/Training";
import Observations from "./pages/Observations";
import NCRRegister from "./pages/NCRRegister";
import Audits from "./pages/Audits";
import Waste from "./pages/Waste";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import LegalCompliance from "./pages/LegalCompliance";
import RiskAssessment from "./pages/RiskAssessment";
import MethodStatement from "./pages/MethodStatement";
import DocumentControl from "./pages/DocumentControl";
import EquipmentCertification from "./pages/EquipmentCertification";
import EmergencyPreparedness from "./pages/EmergencyPreparedness";
import ManagementReview from "./pages/ManagementReview";
import ContractorPerformance from "./pages/ContractorPerformance";
import Notifications from "./pages/Notifications";
import UserManagement from "./pages/UserManagement";
import ActivityLog from "./pages/ActivityLog";
import ContextInterestedParties from "./pages/ContextInterestedParties";
import StrategicRisks from "./pages/StrategicRisks";
import WorkerConsultation from "./pages/WorkerConsultation";
import ManagementOfChange from "./pages/ManagementOfChange";
import AuditNCR from "./pages/AuditNCR";
import IndustrialHygiene from "./pages/IndustrialHygiene";
import EnvironmentalAspects from "./pages/EnvironmentalAspects";
import WasteManifests from "./pages/WasteManifests";
import CalibrationAssets from "./pages/CalibrationAssets";
import ReportsCenter from "./pages/ReportsCenter";
import HseObjectives from "./pages/HseObjectives";
import TrainingMatrix from "./pages/TrainingMatrix";
import EquipmentAssets from "./pages/EquipmentAssets";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={
                <RequireAuth>
                  <HSEProvider>
                    <AppLayout>
                      <Routes>
                        <Route path="/" element={<ExecutiveDashboard />} />
                        <Route path="/monthly-kpi" element={<MonthlyKPI />} />
                        <Route path="/incidents" element={<Incidents />} />
                        <Route path="/inspections" element={<Inspections />} />
                        <Route path="/action-plan" element={<ActionPlan />} />
                        <Route path="/permit-to-work" element={<PermitToWork />} />
                        <Route path="/training" element={<Training />} />
                        <Route path="/observations" element={<Observations />} />
                        <Route path="/ncr-register" element={<NCRRegister />} />
                        <Route path="/audits" element={<Audits />} />
                        <Route path="/waste" element={<Waste />} />
                        <Route path="/legal-compliance" element={<LegalCompliance />} />
                        <Route path="/risk-assessment" element={<RiskAssessment />} />
                        <Route path="/method-statement" element={<MethodStatement />} />
                        <Route path="/document-control" element={<DocumentControl />} />
                        <Route path="/equipment-certification" element={<EquipmentCertification />} />
                        <Route path="/emergency-preparedness" element={<EmergencyPreparedness />} />
                        <Route path="/management-review" element={<ManagementReview />} />
                        <Route path="/contractor-performance" element={<ContractorPerformance />} />
                        <Route path="/context-interested-parties" element={<ContextInterestedParties />} />
                        <Route path="/strategic-risks" element={<StrategicRisks />} />
                        <Route path="/worker-consultation" element={<WorkerConsultation />} />
                        <Route path="/management-of-change" element={<ManagementOfChange />} />
                        <Route path="/audit-ncr" element={<AuditNCR />} />
                        <Route path="/industrial-hygiene" element={<IndustrialHygiene />} />
                        <Route path="/environmental-aspects" element={<EnvironmentalAspects />} />
                        <Route path="/waste-manifests" element={<WasteManifests />} />
                        <Route path="/calibration-assets" element={<CalibrationAssets />} />
                        <Route path="/hse-objectives" element={<HseObjectives />} />
                        <Route path="/training-matrix" element={<TrainingMatrix />} />
                        <Route path="/equipment-assets" element={<EquipmentAssets />} />
                        <Route path="/reports-center" element={<ReportsCenter />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/notifications" element={<Notifications />} />
                        <Route path="/user-management" element={<UserManagement />} />
                        <Route path="/activity-log" element={<ActivityLog />} />
                        <Route path="/settings" element={<Settings />} />
                      </Routes>
                    </AppLayout>
                  </HSEProvider>
                </RequireAuth>
              } />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
